import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Container, Typography } from '@material-ui/core'
import { createGlobalStyle } from 'styled-components'
import img1 from '../assets/Smarctic3.jpg'
import FadeIn from 'react-fade-in/lib/FadeIn'

const GlobalStyle = createGlobalStyle`
  body {
    background: url(${img1}) no-repeat;
    background-color: #000000;
    background-attachment: fixed;
    margin-bottom: 100px;
    background-size: 100%;
  }
`


const LappiAreena = () => (
  <FadeIn transitionDuration="3000">
    <Container>
      <React.Fragment>
        <GlobalStyle  />
      </React.Fragment>
      <Typography variant="h3" style={{ color:'white' }}>Pilot Site Lappi Areena</Typography>
      <div style={{ marginRight:'40%' }}>
        <div className="Pilot-areas">
          Facts
          <Typography variant="subtitle1">Builded: 2003, expanded 2011<br></br>Size: Arena 77m x 55m, practice facilities 30 x 68,5m<br></br>Total roof area: Approx. 6200 m3<br></br>Total Volume: 72000 m3 <br></br>Heating system: District heating <br></br>Heat distribution: Ventilation, radiators, floor heating <br></br>Time of use: 06:00 – 24:00 </Typography>
          <br></br>Installed sensors
          <Typography variant="subtitle1">API for the data of refrigerator system.</Typography>
          <br></br>What we learn?
          <Typography variant="subtitle1">Annual waste heat is approx. 2400 MWh. In theory utilizing waste heat could cover whole heating demand of Arena.  However, average temperature of waste heat is only 34 Celsius, so heat pumps are needed to utilize it.<br></br> Solar energy potential were simulated with several programs. Based on historical consumption data, 189 kW solar plant would be optimal, 98% of produced electricity would be used in the building and only 2% would be sold to the grid.</Typography>
          <br></br>
          <Button
            component={Link}
            to="/Pilot-sites/Lappi-Areena"
            style={{
              fontSize:'35px',
              color: 'white',
              background:'black',
              minWidth:'450px',
              border:'1px solid white',
              margin:'1%'
            }}>Sensor data</Button>




          <br></br>

        </div>
      </div>
    </Container>
  </FadeIn>
)

export default LappiAreena